import {
    POST_CURBSIDE_CHECKIN_INFO,
    POLL_GET_CURBSIDE_CHECKIN_INFO,
    STOP_POLLING_GET_CURBSIDE_CHECKIN_INFO,
    GET_CURBSIDE_PICKUP_ORDER_INFO,
    PATCH_CANCEL_CURBSIDE,
    CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION,
    CURBSIDE_EVENTS_ANALYTICS_ACTION,
    RESET_CURBSIDE_CHECKIN_INFO,
    CURBSIDE_STATUS_INFO_ACTION,
} from '../actionTypes/CurbsideActionTypes';

export const postCurbsideCheckInInfo = (payload, config) => ({
    type: POST_CURBSIDE_CHECKIN_INFO,
    payload,
    config,
});

export const pollGetCurbsideCheckInInfo = (payload, config) => ({
    type: POLL_GET_CURBSIDE_CHECKIN_INFO,
    payload,
    config,
});

export const stopPollingGetCurbsideCheckInInfo = () => ({
    type: STOP_POLLING_GET_CURBSIDE_CHECKIN_INFO,
    payload: {},
});

export const resetCurbsideCheckInInfo = () => ({
    type: RESET_CURBSIDE_CHECKIN_INFO,
    payload: {},
});

export const patchCancelCurbside = (payload) => ({
    type: PATCH_CANCEL_CURBSIDE,
    payload,
});
export const getCurbsidePickupOrderInfo = (payload, config) => ({
    type: GET_CURBSIDE_PICKUP_ORDER_INFO,
    payload,
    config,
});

export const curbsidePickupAnalyticsAction = (payload) => ({
    type: CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION,
    payload,
});

export const curbsideEventAnalytics = (eventName, data) => ({
    type: CURBSIDE_EVENTS_ANALYTICS_ACTION,
    eventName,
    data,
});

export const getCurbsideStatusInfo = (payload) => ({
    type: CURBSIDE_STATUS_INFO_ACTION,
    payload,
});
